export default [
    {
        path: "/bloqueioEntradaNf",
        name: "BloqueioEntradaNf",
        component: () => import("../views/BloqueioNotas"),
        meta: { requiresAuth: true },
    }
]